import { render, staticRenderFns } from "./CommonBadgesLinkList.vue?vue&type=template&id=447dd6db"
import script from "./CommonBadgesLinkList.vue?vue&type=script&lang=js"
export * from "./CommonBadgesLinkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports